export default __webpack_public_path__ + "static/performing-cb26e32e8e2e542ed572e1ba4cfa9651.svg";